var _rect, _path, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullpage = function SvgFullpage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 42,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 42,
    fill: "#EAEDF1",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M0 3a3 3 0 0 1 3-3h48a3 3 0 0 1 3 3v3H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 0.5,
    fill: "var(--groot-primary003)",
    stroke: "#EAEDF1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 3,
    r: 0.5,
    fill: "var(--groot-primary003)",
    stroke: "#EAEDF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3,
    r: 0.5,
    fill: "var(--groot-primary003)",
    stroke: "#EAEDF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 30,
    x: 3,
    y: 9,
    fill: "#666",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    x: 8,
    y: 30,
    fill: "#EAEDF1",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 17,
    y: 17,
    fill: "#EAEDF1",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 2,
    x: 13,
    y: 21,
    fill: "#EAEDF1",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 36,
    y: 30,
    fill: "#EAEDF1",
    rx: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 12,
    r: 1,
    fill: "#EAEDF1"
  })));
};
export { SvgFullpage as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA1NCA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjU0IiBoZWlnaHQ9IjQyIiByeD0iMyIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cGF0aCBkPSJNMCAzQzAgMS4zNDMxNSAxLjM0MzE1IDAgMyAwSDUxQzUyLjY1NjkgMCA1NCAxLjM0MzE1IDU0IDNWNkgwVjNaIiBmaWxsPSIjNjY2NjY2Ij48L3BhdGg+CjxjaXJjbGUgY3g9IjMiIGN5PSIzIiByPSIwLjUiIGZpbGw9InZhcigtLWdyb290LXByaW1hcnkwMDMpIiBzdHJva2U9IiNFQUVERjEiPjwvY2lyY2xlPgo8Y2lyY2xlIGN4PSI2IiBjeT0iMyIgcj0iMC41IiBmaWxsPSJ2YXIoLS1ncm9vdC1wcmltYXJ5MDAzKSIgc3Ryb2tlPSIjRUFFREYxIj48L2NpcmNsZT4KPGNpcmNsZSBjeD0iOSIgY3k9IjMiIHI9IjAuNSIgZmlsbD0idmFyKC0tZ3Jvb3QtcHJpbWFyeTAwMykiIHN0cm9rZT0iI0VBRURGMSI+PC9jaXJjbGU+CjxyZWN0IHg9IjMiIHk9IjkiIHdpZHRoPSI0OCIgaGVpZ2h0PSIzMCIgcng9IjIiIGZpbGw9IiM2NjY2NjYiPjwvcmVjdD4KPHJlY3QgeD0iOCIgeT0iMzAiIHdpZHRoPSIyNiIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cmVjdCB4PSIxNyIgeT0iMTciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cmVjdCB4PSIxMyIgeT0iMjEiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iI0VBRURGMSI+PC9yZWN0Pgo8cmVjdCB4PSIzNi4wMDA0IiB5PSIzMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjQiIHJ4PSIyIiBmaWxsPSIjRUFFREYxIj48L3JlY3Q+CjxjaXJjbGUgY3g9IjQ4IiBjeT0iMTIiIHI9IjEiIGZpbGw9IiNFQUVERjEiPjwvY2lyY2xlPgo8L3N2Zz4=";